module.exports = __webpack_public_path__ + "img/quiz.0d63706a.svg";